<template>
  <ElFormItem
    :class="[
      'ui-time-picker-with-validation',
      {
        'ui-time-picker-with-validation_in-column': props.inColumn,
        'ui-time-picker-with-validation_only-value': props.onlyValue && props.disabled,
        'ui-time-picker-with-validation_in-line-space-between':
          !props.inColumn && !!props.label && props.spaceBetween,
      },
    ]"
    :error="errorMessage"
    :label="props.label"
    :required="required">
    <div v-if="props.onlyValue && props.disabled">{{ value }}</div>
    <ElTimePicker
      v-else
      v-model="value"
      :arrow-control="true"
      :disabled="props.disabled"
      :value-format="valueFormat"
      :format="format"
      :validate-event="false"
      :placeholder="props.placeholder || $t('Base.SetTime')"
      :picker-options="timePickerOptions"
      popper-class="ui-time-picker__popper"
      @change="$emit('change')" />
  </ElFormItem>
</template>

<script lang="ts">
export default {
  name: 'FormTimeField',
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script lang="ts" setup>
import { ElTimePicker } from 'element-plus';
import { useField } from 'vee-validate';
import { withDefaults } from 'vue';

type Props = {
  onlyValue?: boolean;
  inColumn?: boolean;
  spaceBetween?: boolean;
  disabled?: boolean;
  required?: boolean;
  fieldName: string;
  label?: string;
  placeholder?: string;
  format?: string;
  valueFormat?: string;
};

const props = withDefaults(defineProps<Props>(), {
  onlyValue: false,
  inColumn: true,
  spaceBetween: false,
  disabled: false,
  required: false,
  label: '',
  placeholder: '',
  format: 'HH:mm',
  valueFormat: 'HH:mm',
});

const timePickerOptions = {
  start: '06:00',
  end: '21:00',
};

// eslint-disable-next-line vue/no-setup-props-destructure
const { value, errorMessage, setValue } = useField<string>(props.fieldName);

defineExpose({
  value,
  setValue,
});
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/base.locales.json" />
